jQuery(document).ready(function($) {
    // Get all buttons with the class 'listicle-item__button--form'
    $('.listicle-item__button--form').each(function() {
        // Add a click event listener to each button
        $(this).on('click', function() {
            // Get the section from the button's ID
            var section = this.id.replace('listicle_open_', '');
            
            // Find the associated modal using the section
            var modal = $('#listicle_form_' + section).parent('.listicle_form_container');

            // Show the modal
            modal.show();
        });
    });

    // // Close modal when clicking on the overlay
    // $('.listicle_form_overlay').on('click', function() {
    //     // Hide the parent modal
    //     $(this).parent('.listicle_form_container').hide();
    // });

    // Close modal when clicking on the close icon
    $('.close-icon').on('click', function() {
        $('.listicle_form_container').hide();
    });
});
